var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('auth-service',{on:{"login":_vm.afterLogin,"logout":_vm.afterLogout}}),_c('route-service',{ref:"route"}),_c('app-bar'),_c('v-main',[_c('v-container',{ref:"container",staticClass:"fill-height px-0 pt-4 pb-0 pa-md-6",attrs:{"fluid":""}},[_c('div',{staticClass:"fill-width fill-height"},[_c('router-view')],1)])],1),_c('foot-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }